import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import { Container, Card, Row, Col, Button, InputGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { exportStudentExcel } from "./DownloadStudents_Excel";
import ProcessingDialog from './ProcessingDialog';

const Medical_Record = () => {


  const [selectedSection, setSelectedSection] = useState();
  const [ddlSections, setDdlSections] = useState([]);
  
  const [selectedStd, setSelectedStd] = useState();
  const [ddlStds, setDdlStds] = useState([]);
  const [selectedDiv, setSelectedDiv] = useState();
  const [ddlDivisions, setDdlDivisions] = useState([]);

  const [selectedEpilepsy, setSelectedEpilepsy] = useState('Y');
  const [selectedWearGlasses, setSelectedWearGlasses] = useState('Y');
  const [selectedHeartCond, setSelectedHeartCond] = useState('Y');
  const [selectedChrocIll, setSelectedChrocIll] = useState('Y');
  const [selectedAllergies, setSelectedAllergies] = useState('A');
  const [selectedAsthma, setSelectedAsthma] = useState('Y');
  const [selectedDiabetes, setSelectedDiabetes] = useState('Y');
  const [selectedRegMedi, setSelectedRegMedi] = useState('Y');

  const [instituteName, setInstituteName] = useState();

  const [reportData, setReportData] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  const columns = [
    { header: "GR No", field: "gr_no" },
    { header: "Student Name", field: "stud_name" },
    { header: "Gender", field: "gender" },
    { header: "Status", field: "status" },
    { header: "Current Std/Div", field: "curr_std_div" },

    // Medical Details
    { header: "Glasses Details", field: "glasses_details" },
    { header: "Allergies", field: "allergies" },
    { header: "Allergy Details", field: "allergy_details" },
    { header: "Asthma", field: "asthma" },
    { header: "Diabetes", field: "diabetes" },
    { header: "Chronic Illness", field: "illness_details" },
    { header: "Heart Condition", field: "heart_condition" },
    { header: "Blood Group", field: "blood_group" },
    { header: "Hearing", field: "hearing" },
    { header: "Physical Disability", field: "physical_disability" },
    { header: "Height (Admission)", field: "height_admission" },
    { header: "Height (Current)", field: "height_current" },
    { header: "Weight (Admission)", field: "weight_admission" },
    { header: "Weight (Current)", field: "weight_current" },
    { header: "Epilepsy", field: "epilepsy" },
    { header: "Heart Details", field: "heart_details" },
    { header: "Regular Medication", field: "regular_medication" },
    { header: "Medical Remarks", field: "medical_remarks" },

    // Emergency Contact
    { header: "Emergency Contact Name", field: "emg_cont_name" },
    { header: "Emergency Contact Relation", field: "emg_cont_relation" },
    { header: "Emergency Contact Number", field: "emg_cont_number" },

    // Doctor Details
    { header: "Doctor Name", field: "doctor_name" },
    { header: "Doctor Number", field: "doctor_number" },

  ];
/*
  const medicalIcons = {
    asthma: "🫁",
    diabetes: "🍬",
    heart_condition: "❤️",
    epilepsy: "🧠",
    wear_glasses: "👓",
    regular_medication: "💊",
  };

  import {
  FaGlasses,
  FaHeart,
  FaLungs,
  FaPills,
  FaExclamationTriangle,
} from "react-icons/fa";

import { GiBrain } from "react-icons/gi";

const getMedicalAlerts = (row) => {
  const alerts = [];

  if (row.wear_glasses === "Y")
    alerts.push({
      icon: <FaGlasses color="#1976d2" />,
      title: "Wears Glasses",
    });

  if (row.heart_condition === "Y")
    alerts.push({
      icon: <FaHeart color="red" />,
      title: "Heart Condition",
    });

  if (row.asthma === "Y")
    alerts.push({
      icon: <FaLungs color="#0d6efd" />,
      title: "Asthma",
    });

  if (row.diabetes === "Y")
    alerts.push({
      icon: <FaPills color="purple" />,
      title: "Diabetes",
    });

  if (row.epilepsy === "Y")
    alerts.push({
      icon: <GiBrain color="#795548" />,
      title: "Epilepsy",
    });

  if (row.allergies)
    alerts.push({
      icon: <FaExclamationTriangle color="orange" />,
      title: row.allergies,
    });

  return alerts;
};

*/
  useEffect(() => {

    loadDropdowns();

  }, []);

  const loadDropdowns = async () => {

    try {

      const sec = await axios.get(`${BASE_URL}/api/ddl_sections`);
      setDdlSections(sec.data);

    } catch (err) {

      console.error("Error loading Dropdowns", err);

    }

  };

  /// To Populate Standard on change of Section
  useEffect(() => {

    const fetchStandard = async () => {
      try {
        setDdlStds([]);
        setDdlDivisions([]);
        if (selectedSection) {
          const std = await axios.get(`${BASE_URL}/api/ddl_standards`, { params: { p_Section_Id: selectedSection } });
          setDdlStds(std.data);
        }
      } catch (error) {
        console.error("Error fetching Std:", error);
      }
    };

    fetchStandard();

  }, [selectedSection]);

  /// To Populate Division on change of Standard
  useEffect(() => {

    const fetchDivision = async () => {
      try {
        setDdlDivisions([]);
        if (selectedStd) {
          const res = await axios.get(`${BASE_URL}/api/ddl_division`, { params: { p_Std_Id: selectedStd } });
          setDdlDivisions(res.data || []);
        }
      } catch (error) {
        console.error("Error fetching Division:", error);
      }
    };

    fetchDivision();

  }, [selectedStd]);


  // Fetch report
  const handleRunReport = async () => {

    if ((!selectedEpilepsy || selectedEpilepsy === '') &&
      (!selectedWearGlasses || selectedWearGlasses === '') &&
      (!selectedHeartCond || selectedHeartCond === '') &&
      (!selectedChrocIll || selectedChrocIll === '') &&
      (!selectedAllergies || selectedAllergies === '') &&
      (!selectedAsthma || selectedAsthma === '') &&
      (!selectedDiabetes || selectedDiabetes === '') &&
      (!selectedRegMedi || selectedRegMedi === ''))  {
      toast.error("Please select at least one input parameter.");
      return;
    } 

    setReportData([]);
    setIsProcessing(true);

    try {

      const result = await axios.get(`${BASE_URL}/api/rpt_stud_medical`, {
        params: {p_section_id: selectedSection || 0, p_std_id: selectedStd, p_div_id: selectedDiv,
                 p_wear_glasses: selectedWearGlasses || '', p_epilepsy: selectedEpilepsy || '', p_heart: selectedHeartCond || '',
                 p_chroc_ill: selectedChrocIll || '', p_allergy: selectedAllergies || '', p_asthama: selectedAsthma || '',
                 p_diabetic: selectedDiabetes || '', p_reg_med: selectedRegMedi } });

      setIsProcessing(false);

      if (result.data.length > 0) {
        setReportData(result.data);
        //setInstituteName(result.data[0].school_name);
      } else {
        setReportData([]);
        toast.error("No Records Found");
      }
    } catch (err) {
      setIsProcessing(false);
      console.error("Report Error:", err);
      toast.error("Error loading Report.");
    }
  };

  const selectedSectionName = ddlSections.find(sec => sec.section_id === Number(selectedSection))?.section_desc || "";
  // const selectedDivName = ddlDivisions.find(div => div.div_id === Number(selectedDiv))?.div_name || "";

  const handleDownloadExcel = () => {

    if (reportData.length === 0) {
      toast.error("No data to download");
      return;
    }

    exportStudentExcel({
      reportData,
      columns,
      instituteName,
      selectedSectionName,
    });

  };

  return (

    <Container fluid className="p-3">

      {/* Filters */}
      <Card className="p-3 mb-3">

        <Row className="mt-2">

          <Col md={3}>

            <InputGroup>
              <InputGroup.Text style={{ width: "130px" }}>Wear Glasses</InputGroup.Text>
              <select className="form-select" name="selectedWearGlasses"
                value={selectedWearGlasses} onChange={(e) => setSelectedWearGlasses(e.target.value)} >
                <option value="">-- Select --</option>
                <option value="Y">Yes</option>
              </select>
            </InputGroup>

          </Col>

          <Col md={3}>

            <InputGroup>
              <InputGroup.Text style={{ width: "130px" }}>Heart Condition</InputGroup.Text>
              <select className="form-select" name="selectedHeartCond" value={selectedHeartCond}
                onChange={(e) => setSelectedHeartCond(e.target.value)} >
                <option value="">-- Select --</option>
                <option value="Y">Yes</option>
              </select>
            </InputGroup>

          </Col>

          <Col md={3}>
          
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}>Allergies</InputGroup.Text>
              <select className="form-select" name="selectedAllergies" value={selectedAllergies}
                onChange={(e) => setSelectedAllergies(e.target.value)} >
                <option value="">-- Select Allergy --</option>
                {/* <option value="NO">No</option> */}
                <option value="FOOD">Food</option>
                <option value="MEDICINE">Medicine</option>
                <option value="DUST">Dust</option>
                <option value="INSECT">Insect</option>
                <option value="A">Any Allergy</option>
              </select>
            </InputGroup>

          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "150px" }}>Epilepsy</InputGroup.Text>
              <select className="form-select" name="selectedEpilepsy" value={selectedEpilepsy}
                onChange={(e) => setSelectedEpilepsy(e.target.value)} >
                <option value="">-- Select --</option>
                <option value="Y">Yes</option>
              </select>
            </InputGroup>
          </Col>

        </Row>

        <Row className="mt-2">

          <Col md={3}>

            <InputGroup>
              <InputGroup.Text style={{ width: "130px" }}>Chronic Illness</InputGroup.Text>
              <select className="form-select" name="selectedChrocIll" value={selectedChrocIll}
                onChange={(e) => setSelectedChrocIll(e.target.value)} >
                <option value="">-- Select --</option>
                <option value="Y">Yes</option>
              </select>
            </InputGroup>

          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "130px" }}>Asthma</InputGroup.Text>
              <select className="form-select" name="selectedAsthma" value={selectedAsthma}
                onChange={(e) => setSelectedAsthma(e.target.value)} >
                <option value="">-- Select --</option>
                <option value="Y">Yes</option>
              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}>Diabetes</InputGroup.Text>
              <select className="form-select" name="selectedDiabetes" value={selectedDiabetes}
                onChange={(e) => setSelectedDiabetes(e.target.value)} >
                <option value="">-- Select --</option>
                <option value="Y">Yes</option>
              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "155px" }}>Regular Medication</InputGroup.Text>
              <select className="form-select"
                name="selectedRegMedi" value={selectedRegMedi}
                onChange={(e) => setSelectedRegMedi(e.target.value)} >
                <option value="">-- Select --</option>
                <option value="Y">Yes</option>
              </select>
            </InputGroup>
          </Col>

        </Row>

        <Row className="mt-2">

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "130px" }}> Section 
              </InputGroup.Text>

              <select className="form-select" name="selectedSection" 
                value={selectedSection} onChange={(e) => setSelectedSection(e.target.value)} >
                <option value="">Select Section</option>
                {ddlSections.map(s => (
                  <option key={s.section_id} value={s.section_id}>{s.section_desc}</option>))}
              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text style={{ width: "130px" }}> Standard
              </InputGroup.Text>
              <select className="form-select"
                name="selectedStd" value={selectedStd} onChange={(e) => setSelectedStd(e.target.value)} >
                <option value="">--Select Standard--</option>
                {ddlStds.map(std => (
                  <option key={std.std_id} value={std.std_id}>{std.std_name}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={3}>

            <InputGroup>
              <InputGroup.Text style={{ width: "120px" }}>Division
              </InputGroup.Text>
              <select className="form-select" name="selectedDiv"
                value={selectedDiv} onChange={(e) => setSelectedDiv(e.target.value)} >
                <option value="">-- Select Division --</option>
                {ddlDivisions.map(div => (
                  <option key={div.div_id} value={div.div_id}>{div.div_name}</option>
                ))}
              </select>
            </InputGroup>

          </Col>

          <Col md={3}>
            <Button variant="warning" className="ms-2" onClick={handleDownloadExcel}
              disabled={reportData.length === 0}> Download Excel
            </Button>
            <Button variant="success" onClick={handleRunReport} className="ms-2"> Run Report</Button>
            {isProcessing && <ProcessingDialog isOpen={isProcessing} />}
          </Col>

        </Row>

      </Card>

      {/* Report Table style={{ minHeight: '220px' }} */}
      <Card className="p-3">
        <div className="responsive-table-reports-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table-reports scty-custom-table-rcpt hover-table-rcpt">
            <thead className="table-light">
              <tr>
                {columns.map(col => (
                  <th key={col.field}>{col.header}</th>
                ))}
              </tr>
            </thead>

            <tbody>
              {reportData.length > 0 ? (
                reportData.map((row) => (
                  <tr key={row.student_id}>
                    {columns.map(col => (
                      <td key={col.field}>
                        {row[col.field]}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length} className="text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>

          </table>
        </div>

      </Card>

    </Container>
  );
};

export default Medical_Record;
